const types = {
  UPDATE_USER_LIST: "UPDATE_USER_LIST",
  IS_LOADING_USERS: "IS_LOADING_USERS",
  ADD_USER_TO_LIST: "ADD_USER_TO_LIST",
  UPDATE_COLLAB_SELECTED: "UPDATE_COLLAB_SELECTED",
  DELETE_USER_TO_LIST: "DELETE_USER_TO_LIST",
};

export default types;
